import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "post"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "flex space-between" }, [
      /*#__PURE__*/_createTextVNode("Author"),
      /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "كاتب")
    ])
  ])
], -1)
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "wrap-author" }
const _hoisted_5 = {
  key: 0,
  class: "author-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "image box-shadow reversed nohover"
}
const _hoisted_7 = { class: "author-content" }
const _hoisted_8 = { class: "author-name" }
const _hoisted_9 = { class: "country" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "flex space-between" }, [
  /*#__PURE__*/_createTextVNode("Related Articles "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "قراءات مماثلة")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "author-wrap"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "author-content" }
const _hoisted_16 = { class: "author-name" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "country" }
const _hoisted_19 = { class: "bio" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    id: "authorWrap",
    class: _normalizeClass(["view", {'scrolled': _ctx.scrolled}])
  }, [
    (_ctx.activePost)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.activePost.custom_fields.language)
              }, [
                (_ctx.activePost)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_ctx.activePost.custom_fields.image)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "image box-shadow reversed nohover",
                            style: _normalizeStyle({ 'background-image': 'url('+_ctx.activePost.custom_fields.image.sizes.medium+')'})
                          }, null, 4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.activePost.post_title), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.activePost.custom_fields.country), 1),
                        _createElementVNode("div", {
                          class: "bio",
                          innerHTML: _ctx.activePost.post_content
                        }, null, 8, _hoisted_10)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _hoisted_11,
              (_ctx.relatedPost)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.relatedPost, (post, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(post.custom_fields.language)
                    }, [
                      post
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (post.custom_fields.image)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: "",
                                  onClick: $event => (_ctx.goToBlog(post,$event)),
                                  class: "image box-shadow reversed",
                                  style: _normalizeStyle({ 'background-image': 'url('+post.custom_fields.image.sizes.medium+')'})
                                }, null, 12, _hoisted_13))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: "",
                                  onClick: $event => (_ctx.goToBlog(post,$event)),
                                  class: "image box-shadow reversed"
                                }, null, 8, _hoisted_14)),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("p", _hoisted_16, [
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: $event => (_ctx.goToBlog(post,$event))
                                }, _toDisplayString(post.post_title), 9, _hoisted_17)
                              ]),
                              _createElementVNode("p", _hoisted_18, _toDisplayString(post.custom_fields.country), 1),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("p", null, _toDisplayString(post.custom_fields.intro_text), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}